import { LineItemTextField } from "components/formFields/LineItemTextField";

export function LineNotes(props) {
  const { value, onValueChange } = props;

  return (
    <LineItemTextField
      resize
      multiline
      name="notes"
      maxRows={4}
      value={value || ""}
      onValueChange={onValueChange}
    />
  );
}
